import styled from 'styled-components';

const Spin = styled.div`
  border-radius: 50%;
  width: 10em;
  height: 10em;
  margin: 60px auto;
  font-size: 10px;
  position: relative;
  text-indent: -9999em;
  border-top: 1.1em solid rgba(0, 170, 255, 0.2);
  border-right: 1.1em solid rgba(0, 170, 255, 0.2);
  border-bottom: 1.1em solid rgba(0, 170, 255, 0.2);
  border-left: 1.1em solid #00aaff;
  transform: translateZ(0);
  animation: spin 1.1s infinite linear;

  &:after {
    border-radius: 50%;
    width: 10em;
    height: 10em;
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

function Spinner({ className }: { className?: string }) {
  return <Spin className={className} />;
}

export { Spinner };
